import React from 'react';

/**
 * Single rounded card with N cells separated by thin vertical dividers.
 * On mobile, cells stack into a 2-column grid; from md+ they become a single
 * horizontal row driven by inline gridTemplateColumns (so cell count is dynamic
 * without depending on Tailwind's purger seeing a literal `md:grid-cols-N`).
 *
 * @param {{ cells: Array<{ label: React.ReactNode, value: React.ReactNode, subtext?: React.ReactNode, valueClassName?: string, badge?: React.ReactNode }>, className?: string }} props
 */
export default function AnalyticsStatStrip({ cells = [], className = '' }) {
  if (!cells.length) return null;

  return (
    <div
      className={`rounded-xl bg-surface dark:bg-gray-870 border border-gray-200/70 dark:border-gray-600/70 shadow-sm overflow-hidden ${className}`}
    >
      {/* Mobile: 2-column grid, dividers between rows. md+: single row via inline columns. */}
      <div
        className="grid grid-cols-2 md:flex divide-y divide-x-0 md:divide-y-0 md:divide-x divide-gray-100 dark:divide-gray-700"
      >
        {cells.map((cell, i) => (
          <div key={i} className="flex-1 px-5 py-4 min-w-0">
            <div className="text-[11px] uppercase tracking-wider font-medium text-gray-500 dark:text-gray-400 mb-1">
              {cell.label}
            </div>
            <div
              className={`text-2xl sm:text-3xl font-medium tracking-tight font-mono tabular-nums leading-tight text-gray-900 dark:text-gray-100 ${cell.valueClassName || ''}`}
            >
              {cell.value}
            </div>
            {cell.subtext != null ? (
              <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{cell.subtext}</div>
            ) : null}
            {cell.badge ? <div className="mt-1.5">{cell.badge}</div> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
